module.exports = __webpack_public_path__ + "static/media/AppStore_Deutsch.b37fbda5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AppStore_Deutsch.svg
// module id = 302
// module chunks = 21